import clsx from 'clsx'
import React, { FC } from 'react'

import Truck from '@Assets/SVG/Truck'
import { SVGIcon } from '@Components/Icons/SVGIcon'
import { PageType } from '@Generated/graphql'
import { useCMSModalOpen } from '@Globals/CMS/Modal/Hook'
import { useSplitTest } from '@Globals/SplitTests/Hooks'
import { useTranslation } from '@Globals/Translations'

import styles from './DeliveryCartField.module.scss'

export interface DeliveryCartFieldProps {
  className?: string
  expectedDelivery: string
  hideButton?: boolean
  iconClassName?: string
  v2?: boolean
}

export const DeliveryCartField: FC<DeliveryCartFieldProps> = ({ className, expectedDelivery, hideButton, iconClassName, v2 = false }) => {
  const splitTest = useSplitTest('lead_time_hide_v1')
  const { t } = useTranslation('shipping')
  const openModal = useCMSModalOpen()

  if (v2) {
    return (
      <div className={clsx(styles.deliveryCartField, v2 && styles.v2, className)}>
        {splitTest === 'a' && (
          <span>
            {`${t('cart:EXPECTED_DELIVERY_LABEL')} `}
            <span>
              {expectedDelivery.indexOf('-') !== -1
                ? t('cart:X_WEEKDAYS', `${expectedDelivery} working days`, { arg1: expectedDelivery })
                : t('cart:ONE_WEEKDAY')}
              {' '}
            </span>
          </span>
        )}
        {' '}
        {!hideButton && (
          <button onClick={() => openModal(PageType.Modal, '20', 'cart')} type="button">
            {t('header:SEE_SHIPPING_OPTIONS')}
          </button>
        )}
      </div>
    )
  }

  return (
    <div className={clsx(styles.deliveryCartField, className)}>
      <SVGIcon className={clsx(styles.icon, iconClassName)} icon={Truck} />
      {splitTest === 'a' && (
        <span>
          {`${t('cart:EXPECTED_DELIVERY_LABEL')} `}
          <span>
            {expectedDelivery.indexOf('-') !== -1
              ? t('cart:X_WEEKDAYS', `${expectedDelivery} working days`, { arg1: expectedDelivery })
              : t('cart:ONE_WEEKDAY')}
            {' '}
          </span>
        </span>
      )}
      {' '}
      {!hideButton && (
        <button onClick={() => openModal(PageType.Modal, '20', 'cart')} type="button">
          {t('header:SEE_SHIPPING_OPTIONS')}
        </button>
      )}
    </div>
  )
}

